<div class="donut-chart chart1">
  <div class="slice one"></div>
  <div class="slice two"></div>
  <div class="chart-center">
    <span></span>
  </div>
</div>